module.exports = __webpack_public_path__ + "static/media/compare_88.1a4a3025.svg";